import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import logo from '../logo.png';

const links = ['Services', 'Why Us', 'About', 'Contact'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id.toLowerCase().replace(' ', '-'))?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: scrolled ? 'rgba(255,255,255,0.94)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(0,172,193,0.16)' : 'none',
        boxShadow: scrolled ? '0 16px 40px rgba(15,23,42,0.08)' : 'none',
        transition: 'all 0.4s ease',
        padding: '0 5%',
      }}
    >
      <div style={{ maxWidth: 1280, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 72 }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={logo} alt="KP Technologies" style={{ height: 44, width: 'auto' }} />
          <span style={{ fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 20, color: 'var(--teal-dark)', letterSpacing: '0.05em', display: 'none' }}
            className="nav-brand">KP TECHNOLOGIES</span>
        </div>

        {/* Desktop links */}
        <div style={{ display: 'flex', gap: 36, alignItems: 'center' }} className="nav-desktop">
          {links.map(link => (
            <button key={link} onClick={() => scrollTo(link)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontFamily: 'Rajdhani', fontWeight: 600, fontSize: 15,
                color: 'var(--text-muted)', letterSpacing: '0.08em',
                textTransform: 'uppercase', transition: 'color 0.2s',
                padding: '4px 0', position: 'relative',
              }}
              onMouseEnter={e => e.target.style.color = 'var(--teal-dark)'}
              onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
            >{link}</button>
          ))}
          <a href="https://wa.me/919988778877" target="_blank" rel="noreferrer"
            style={{
              background: 'linear-gradient(135deg, var(--teal), var(--teal-dark))',
              color: '#fff', fontFamily: 'Rajdhani', fontWeight: 700,
              fontSize: 14, letterSpacing: '0.08em', textTransform: 'uppercase',
              padding: '9px 22px', borderRadius: 4, transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => e.target.style.opacity = '0.85'}
            onMouseLeave={e => e.target.style.opacity = '1'}
          >Get in Touch</a>
        </div>

        {/* Hamburger */}
        <button onClick={() => setOpen(!open)} className="nav-hamburger"
          style={{ background: 'none', border: 'none', color: 'var(--teal-dark)', cursor: 'pointer', display: 'none' }}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
            style={{ background: 'rgba(255,255,255,0.98)', borderTop: '1px solid rgba(0,172,193,0.16)', padding: '16px 5%' }}>
            {links.map(link => (
              <div key={link} onClick={() => scrollTo(link)}
                style={{ padding: '14px 0', fontFamily: 'Rajdhani', fontWeight: 600, fontSize: 18, color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase', cursor: 'pointer', borderBottom: '1px solid rgba(15,23,42,0.08)' }}>
                {link}
              </div>
            ))}
            <a href="https://wa.me/919988778877" target="_blank" rel="noreferrer"
              style={{ display: 'block', marginTop: 16, background: 'linear-gradient(135deg, var(--teal), var(--teal-dark))', color: '#fff', fontFamily: 'Rajdhani', fontWeight: 700, fontSize: 15, letterSpacing: '0.08em', textTransform: 'uppercase', padding: '12px 22px', borderRadius: 4, textAlign: 'center' }}>
              Get in Touch
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-hamburger { display: block !important; }
        }
      `}</style>
    </motion.nav>
  );
}
